import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import styles from './Tutorial.scss';

export default class Tutorial extends Component {
  state = {
    currentStep: 1,
    steps: [
      {
        hint: `The on-screen icons are controlled using the modules push buttons (highlighted).
                Click or tap the modules push buttons to simulate a response.`,
        action: 'Skip'
      },
      {
        hint: `Double click the left push button.
              Then, click the right push button to simulate pressing both buttons simultaneously.
              This provides access to the menu selection screen.`,
        action: 'Start simulation'
      }
    ]
  };

  componentDidMount() {
    this.focusContent();

    this.root = document.querySelector('#app');

    if (this.root) {
      this.root.style.overflow = 'hidden';
      this.root.style.height = '1vh';
    }
  }

  componentDidUpdate() {
    this.focusContent();
  }

  componentWillUnmount() {
    if (this.root) {
      this.root.removeAttribute('style');
    }
  }

  focusContent() {
    this.wrapper.focus();
  }

  changeStep(step) {
    this.setState({
      currentStep: step
    });
  }

  navigateToStep = step => () => {
    this.changeStep(step);
  }

  keyNavigation = (e) => {
    const key = e.keyCode;
    const { currentStep } = this.state;
    let newStep;

    if (key === 37 && currentStep !== 1) {
      newStep = 1;
    } else if (key === 39 && currentStep !== 2) {
      newStep = 2;
    } else {
      return;
    }

    this.changeStep(newStep);
  }

  render() {
    const { currentStep, steps } = this.state;
    const step = steps[currentStep - 1];
    const imageClass = `step-${currentStep}`;

    return (
      <div
        className={styles.wrapper}
        onKeyUp={this.keyNavigation}
        tabIndex="0"
        role="button"
        ref={(elem) => { this.wrapper = elem; }}
      >
        <div className={styles.overlay}>
          <div className={styles.content}>
            <h2 className={styles.heading}>Tutorial</h2>
            <h4 className={styles.subheading}>Step {currentStep} of 2</h4>
            <div className={styles.main}>
              <button
                className={`${styles.arrow} ${currentStep === 1 ? styles.hidden : ''}`}
                onClick={this.navigateToStep(1)}
              >
                <i className={styles['icon-xm-left-chevron']} />
              </button>
              <div className={`${styles[imageClass]}`} />
              <button
                className={`${styles.arrow} ${currentStep === 2 ? styles.hidden : ''}`}
                onClick={this.navigateToStep(2)}
              >
                <i className={styles['icon-xm-right-chevron']} />
              </button>
            </div>
            <div className={styles.hint}>
              <div>{step.hint}</div>
            </div>
          </div>
          <div className={styles.action}>
            <Link to="/">{step.action}</Link>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Tutorial/Tutorial.js